module.exports = __webpack_public_path__ + "img/icon-children.39886a80.svg";